'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import ProgressiveImage from '@/ui/segments/landing/components/progressive-image/progressive-image';
import { IconEye } from '@/ui/segments/landing/icons/icon-eye';
import { styleButtonHoverable } from '@/ui/segments/landing/styles';
import { classNames } from '@/util/utils';
import type { ContentForRepository } from '@/services/sanity/api/get-repositories-content';
import styles from './repository-card.module.css';
interface RepositoryCardProps {
  className?: string;
  value: ContentForRepository;
  showHeader?: boolean;
}
export default function RepositoryCard(t0) {
  const $ = _c(40);
  const {
    className,
    value,
    showHeader
  } = t0;
  const [textExpanded, setTextExpanded] = useState(false);
  let t1;
  if ($[0] !== textExpanded || $[1] !== value.description) {
    t1 = textExpanded ? value.description : `${value.description.slice(0, 200)}...`;
    $[0] = textExpanded;
    $[1] = value.description;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const textContent = t1;
  let t2;
  if ($[3] !== className) {
    t2 = classNames(className, "group relative w-full overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm transition-all duration-300 ease-in-out hover:scale-[0.98] hover:shadow-lg");
    $[3] = className;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== value.imageHeight || $[6] !== value.imageURL || $[7] !== value.imageWidth || $[8] !== value.title) {
    t3 = value.imageURL ? <div className="h-full w-full transition-transform duration-300 group-hover:scale-105"><ProgressiveImage src={value.imageURL} width={value.imageWidth} height={value.imageHeight} className="h-full w-full" /></div> : <div className="flex h-full items-center justify-center bg-linear-to-br from-blue-100 to-purple-100"><span className="text-4xl font-sans font-bold text-gray-400">{value.title?.charAt(0) ?? "?"}</span></div>;
    $[5] = value.imageHeight;
    $[6] = value.imageURL;
    $[7] = value.imageWidth;
    $[8] = value.title;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="absolute inset-0 bg-linear-to-t from-black/20 to-transparent" />;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3) {
    t5 = <div className="relative h-48 w-full overflow-hidden bg-gray-100">{t3}{t4}</div>;
    $[11] = t3;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== value.title) {
    t6 = <div className="mb-3 flex items-start justify-between"><h3 className="text-primary-9 font-serif! line-clamp-2 text-4xl! group-hover:text-blue-600">{value.title}</h3></div>;
    $[13] = value.title;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== textContent) {
    t7 = <p className="text-primary-9 line-clamp-3 leading-normal hyphens-auto">{textContent}</p>;
    $[15] = textContent;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== textExpanded) {
    t8 = () => setTextExpanded(!textExpanded);
    $[17] = textExpanded;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const t9 = textExpanded ? "Read less" : "Read more";
  let t10;
  if ($[19] !== t8 || $[20] !== t9) {
    t10 = <button type="button" aria-label="Read more" className="mt-1 text-sm font-light text-gray-500 hover:text-gray-700" onClick={t8}>{t9}</button>;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="relative my-4 h-px w-full bg-gray-200" />;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== showHeader || $[24] !== value.type) {
    t12 = showHeader && <div className="text-primary-9 mb-4 flex items-center text-base"><span className="font-medium">Type:</span><span className="ml-1">{value.type}</span></div>;
    $[23] = showHeader;
    $[24] = value.type;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t10 || $[27] !== t12 || $[28] !== t6 || $[29] !== t7) {
    t13 = <div className="p-6">{t6}{t7}{t10}{t11}{t12}</div>;
    $[26] = t10;
    $[27] = t12;
    $[28] = t6;
    $[29] = t7;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== value.buttons) {
    t14 = value.buttons.map(_temp);
    $[31] = value.buttons;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t14) {
    t15 = <div className={styles.buttons}>{t14}</div>;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t13 || $[36] !== t15 || $[37] !== t2 || $[38] !== t5) {
    t16 = <div className={t2}>{t5}{t13}{t15}</div>;
    $[35] = t13;
    $[36] = t15;
    $[37] = t2;
    $[38] = t5;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  return t16;
}
function _temp(btn) {
  return <a className={classNames(styles.button, styleButtonHoverable)} href={btn.link} target="_blank" key={btn.title} rel="noopener"><div>{btn.title ?? "View resource"}</div><IconEye /></a>;
}